// hooks/useApiLoading.ts
import { useEffect, useState } from 'react';
import { apiEventEmitter } from '../utils/api/apiEventEmitter';
import { HttpMethod } from '../utils/api/apiTypes';

// Global loading hook
export const useApiLoading = () => {
  const [isLoading, setIsLoading] = useState(false);

  useEffect(() => {
    const unsubscribe = apiEventEmitter.addListener(event => {
      if (event.url === undefined) {
        setIsLoading(event.isLoading);
      }
    });
    return unsubscribe;
  }, []);

  return isLoading;
};

// Endpoint-specific loading hook
export const useEndpointLoading = (
  endpoint: string,
  method: HttpMethod = 'GET'
) => {
  const [isLoading, setIsLoading] = useState(false);

  useEffect(() => {
    const unsubscribe = apiEventEmitter.addListener(event => {
      if (event.url === endpoint && event.method === method.toUpperCase()) {
        setIsLoading(event.isLoading);
      }
    });
    return unsubscribe;
  }, [endpoint, method]);

  return isLoading;
};

// Multiple endpoints loading hook
export const useEndpointsLoading = (
  endpoints: Array<{ url: string; method?: string }>
) => {
  const [isLoading, setIsLoading] = useState(false);

  useEffect(() => {
    const unsubscribe = apiEventEmitter.addListener(event => {
      if (event.url && event.method) {
        const shouldTrack = endpoints.some(
          ep =>
            ep.url === event.url &&
            (!ep.method || ep.method.toUpperCase() === event.method)
        );
        if (shouldTrack) {
          setIsLoading(event.isLoading);
        }
      }
    });
    return unsubscribe;
  }, [endpoints]);

  return isLoading;
};
